import {assertThat, isDefined, isNotDefined} from './Functions'

class LinkBuilder {
    constructor(linksNode) {
        this.node = linksNode
    }

    validate(change) {
        assertThat(change.rel).matches(/^\S+$/, 'Unsupported syntax for \'rel\' argument. It should match pattern \'xxxxx\'')
        assertThat(change.type).matches(/^[\w-]+(?:\/\w+)+$/, 'Unsupported syntax for \'type\' argument. It should match pattern \'xxx/yy\' or \'xxxx\'')
        assertThat(change.uri)
            .whenDefined()
            .matches(/^\S+$/, 'Unsupported syntax for \'uri\' argument. It should match pattern \'xxxx\'')
        assertThat(change.uuid)
            .whenDefined()
            .matches(/^\S+$/, 'Unsupported syntax for \'uuid\' argument. It should match pattern \'xxxx\'')

        if (isDefined(change.links)) {
            change.links.forEach((linkInstruction) => {
                this.validate(linkInstruction)
            })
        }

        if (change.data) {
            Object.keys(change.data).forEach((key) => {
                assertThat(key).matches(/^\S+$/, 'Unsupported syntax for \'data\' element, It should match pattern \'xxxx\'')
            })
        }

        return this
    }

    execute(change) {
        const link = this.node
            .create({
                element: 'link',
                attributeDefinitions: {
                    rel: change.rel,
                    type: change.type
                }
            })
        link.setAttributesFromFields({source: change, fields: ['title', 'uuid', 'uri']})
        this.createDataBlock({source: change.data, node: link})

        if (isDefined(change.links)) {
            const links = link.getOrCreate({element: 'links'})

            change.links.forEach((linkInstruction) => {
                new LinkBuilder(links).execute(linkInstruction)
            })
        }
    }

    createDataBlock({source, node}) {
        if (isNotDefined(source)) {
            return
        }

        const dataNode = node.create({element: 'data'})
        Object.entries(source).forEach(([key, value]) => {
            if (value.attributes && value.value) {
                dataNode.create({element: key, attributeDefinitions: value.attributes}).setText(value.value)
            } else {
                dataNode.create({element: key}).setText(value)
            }
        })
    }
}

export {LinkBuilder}
